import React, { useState, useEffect } from "react";
// import "./memberCSV.css"
import * as Moment from "moment";
import styled, { css } from "styled-components";
import * as _ from "lodash";
import { ReadStream } from "fs";

const MembersCsvWrapper = styled.div`
  display: block;
  flex-direction: column;
  padding: 0px;
  padding-right: 0px;
`;

const MemberLineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 2px dotted #aaa;
  /* padding-bottom: 10px; */
  padding-top: 10px;

  ${props =>
    props.pageBreak &&
    css`
      @media print {
        margin-top: 50px;
        page-break-before: always;
        break-before: always;
      }
    `}
`;
const CsvHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 10px;
`;

const ImageDiv = styled.div`
  img {
    width: 40px;
  }
`;

const TitleWrap = styled.div`
  display: flex;
  flex-direction: row;
  vertical-align: bottom;

  h1 {
    color: #b00;
    margin: 0;
    margin-left: 10px;
    font-size: 1em;
    flex: 1 1 auto;
    align-self: flex-end;
    font-weight: 800;
  }

  h2 {
    color: #555;
    margin: 0;
    margin-left: 3px;
    font-size: 1em;
    flex: 1 1 auto;
    align-self: flex-end;
    font-weight: 800;
  }

  h3 {
    color: #888;
    margin: 0;
    margin-left: 10px;
    font-size: 0.8em;
    flex: 1 1 auto;
    align-self: flex-end;
  }
`;

const MemberCsvTable = styled.table`
  background: white;
  font-size: 0.8em;
  /* margin-top: 10px; */
  border-spacing: 0;

  page-break-before: always;

  @media print {
    page-break-inside: auto;
    break-inside: auto;
  }
  /* page-break-inside: avoid;
  break-inside: avoid; */
  /* .header th {
    text-align: left;
  }

  tr.header td {
    border-bottom: 2px solid black;
    font-weight: bold;
  } */
`;

const MemberTr = styled.tr`
  td {
    min-width: 35%;
    background: white;
    margin: 0;
    padding: 0;
    padding-right: 10px;
    padding-bottom: 15px;
    vertical-align: top;
    font-weight: bold;
    font-size: 1em;
    
    @media print  {
    page-break-inside:avoid;
    break-inside:avoid;
    }
/* 
    ${props =>
      props.prevRankWasDifferent
        ? css`
            padding-top: 4px;
            border-top: 2px solid #000;
          `
        : css`
            padding-top: 4px;
          `} */
  }

  td img {
    width: 16px;
  }
`;
const Box = styled.div`
  border: 1px solid #555;
  width: 16px;
  height: 16px;
`;
const TestHeaderTr = styled.tr`
  font-size: 0.7em;
  margin-top: 40px;
  color: #999;
`;

const TestPointsTr = styled.tr``;
const TestPointsTd = styled.td``;
const TestPointsDiv = styled.div`
  /* min-height: 40px; */
`;
const ImportSvgImg = styled.img`
  width: 100%;
`;

const MemberTestSheet = props => {
  console.log("member CSV called!");
  let membersList = [...props.filteredMembers];
  let memberRanks = [];

  const [hideMember, setHideMember] = useState({});

  const withLatestRank = membersList.map(member => {
    memberRanks = props.ranks.filter(rank => {
      return rank.MemberId == member.ID;
    });

    const currentRank = memberRanks.length > 0 ? memberRanks[0] : null;

    return {
      ...member,
      currentRank,
      currentRankImage:
        currentRank && currentRank.level
          ? "/" + currentRank.level.LevelImage
          : null
    };
  });

  const sortedMembersList = _.sortBy(withLatestRank, [
    "currentRank.LevelId",
    "FirstName"
  ]);

  const sprtedMemberListWithRankSeperator = sortedMembersList.reduce(
    (all, member) => {
      member.prevRankWasDifferent =
        _.last(all) && _.last(all).currentRank && member.currentRank
          ? member.currentRank.LevelId != _.last(all).currentRank.LevelId
          : false;

      return [...all, member];
    },
    []
  );

  const handleHideMember = member => {
    console.log("hiding member!:", member);

    // const m = hideMember...
    // console.log("mem:", m)
    setHideMember({ ...hideMember, [member.ID]: true});
  };

  let memberCount = -1;
  let newPage = false;
  membersList = sprtedMemberListWithRankSeperator.map(member => {
    // Handle page break
    memberCount++;
    newPage = false;

    if (memberCount == 3 || member.prevRankWasDifferent) {
      newPage = true;
      memberCount = 0;
    }

    const memberLine = member.currentRank ? (
      <MemberTr
        key={member.ID}
        prevRankWasDifferent={member.prevRankWasDifferent}
      >
        <td>
          <Box />
        </td>
        <td>{member.FirstName}</td>
        <td>{member.LastName}</td>
        <td>{Moment(member.Birthdate).format("DDMMMYY")}</td>
        <td>{Moment().diff(Moment(member.Birthdate), "years", false)} år</td>
        <td>
          {member.currentRank
            ? Moment(member.currentRank.RankDate).format("DDMMMYY")
            : "N/A"}
        </td>
        <td>
          {member.currentRank
            ? Moment(member.currentRank.RankDate).fromNow()
            : "N/A"}
        </td>
        <td>{member.currentRank.level.LevelTitle}</td>
        <td className="item image">
          <img className="rank" src={member.currentRankImage} />
        </td>
      </MemberTr>
    ) : (
      <tr key={member.ID}>
        <td>
          <Box />
        </td>
        <td>{member.FirstName}</td>
        <td>{member.LastName}</td>
        <td>{Moment(member.Birthdate).format("DDMMMYY")}</td>
        <td>{Moment().diff(Moment(member.Birthdate), "years", false)} år</td>
        <td />
        <td />
        <td>Begynder</td>
        <td />
      </tr>
    );

    return (
      !hideMember[member.ID] && (
        <>
          <MemberLineWrapper id="MemberLineWrapper" pageBreak={newPage}>
            <CsvHeader id="CsvHeader">
              <ImageDiv>
                <img src="/icons/apple-icon-114x114.png" />
              </ImageDiv>
              <TitleWrap onClick={() => handleHideMember(member)}>
                <h1>Skovbo Karate Klub</h1>
                <h2>
                  {props.teamId == -1
                    ? "Alle"
                    : props.teams && props.teams[props.teamId].TeamName}
                </h2>
                <h3>{Moment().format("DDMMMYY")}</h3>
              </TitleWrap>
            </CsvHeader>

            <MemberCsvTable>
              <tbody>
                <TestHeaderTr>
                  <td>Bet</td>
                  <td>Fornavn</td>
                  <td>Efternavn</td>
                  <td>Født</td>
                  <td>Alder</td>
                  <td>Grad dato</td>
                  <td />
                  <td>Grad</td>
                  <td>Grad</td>
                </TestHeaderTr>
                {memberLine}
                <TestPointsTr>
                  <TestPointsTd colSpan="9">
                    <TestPointsDiv>
                      {props.teamId != 0 ? (
                        <ImportSvgImg src="/images/skk-test-sheet.svg" />
                      ) : (
                        <ImportSvgImg src="/images/skk-test-sheet-bh.svg" />
                      )}
                    </TestPointsDiv>
                  </TestPointsTd>
                </TestPointsTr>
              </tbody>
            </MemberCsvTable>
          </MemberLineWrapper>
        </>
      )
    );
  });

  return <MembersCsvWrapper>{membersList}</MembersCsvWrapper>;
};

export default MemberTestSheet;
